module.exports = __webpack_public_path__ + "static/img/Gacha14.58ef5a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/gasha/Gacha14.png
// module id = 4Rt4
// module chunks = 1